import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Avatar} from 'shared/components';

const InterviewInviteBookingActionEntry = observer(({entry, candidate}) => {
  return (
    <div className='clearfix border-top p3'>
      <div className='col col-1 pr1'>
        <Avatar employee={candidate} size='sm' className='left'/>
      </div>
      <div className='col col-11 pl1'>
        <div className='clearfix'>
          <div className='col col-12'>
            <div className='table-cell pr1'>
              <div className='h3 medium'>
                <FormattedMessage id={`recruiting.hiring_funnel.interview_invite_actions.${entry.action}`}/>
              </div>
              <div className='h5 jumbo'>{candidate.name}</div>
            </div>
            <div className='table-cell pl1'>
              <div className='h5 jumbo'>{entry.date}</div>
            </div>
          </div>
          <div className='col col-12 pt2'>
            <div className='h3'>{entry.interviewInvite.scheduleName}</div>
            {entry.action === 'cancelled' && <div className='line-through'>{entry.previousEventStartsAtView}</div>}
            {entry.action === 'scheduled' && <div>{entry.eventStartsAtView}</div>}
          </div>
        </div>
      </div>
    </div>
  );
});

export default InterviewInviteBookingActionEntry;
